module.exports = __webpack_public_path__ + "img/menu_btn.e22eac0c.png";